/* eslint-disable complexity */
import React from 'react';
import {getQueryString} from '../utils/queryParsing';

const AboutQuizModal = props => {
    const getAboutQuizModalCopy = () => {
        switch (getQueryString().m) {
        case `1` :
            return {
                header    : `It seems like you’re interested in learning more about growing your family.`,
                subheader : `Let's find information just for you.`
            };
        case `2` :
            return {
                header    : `It seems like you’re interested in learning more about retirement.`,
                subheader : `Let's find information just for you.`
            };
        case `3` :
            return {
                header    : `It seems like you’re interested in learning more about empty nesting.`,
                subheader : `Let's find information just for you.`
            };
        case `4` :
            return {
                header    : `It seems like you’re interested in learning more about life with a disability.`,
                subheader : `Let's find information just for you.`
            };
        default : return {};
        }
    };

    const copy = getAboutQuizModalCopy();

    return (
        props.display && <section className="about-container">
            <div className="about-metadata-container">
                <h1>{copy.header}</h1>
                <p>{copy.subheader}</p>
            </div>
        </section>
    );
};
export default AboutQuizModal;
